import { __awaiter as d, __generator as f, __assign as R } from "./index11.js";
import { loadScript as g } from "./index50.js";
import { getCDN as k } from "./index31.js";
import { applyDestinationMiddleware as q } from "./index9.js";
import { Context as F } from "./index14.js";
import { ContextCancelation as B } from "./index43.js";
var U = (
  /** @class */
  function() {
    function n(r, t) {
      this.version = "1.0.0", this.alternativeNames = [], this.middleware = [], this.alias = this._createMethod("alias"), this.group = this._createMethod("group"), this.identify = this._createMethod("identify"), this.page = this._createMethod("page"), this.screen = this._createMethod("screen"), this.track = this._createMethod("track"), this.action = t, this.name = r, this.type = t.type, this.alternativeNames.push(t.name);
    }
    return n.prototype.addMiddleware = function() {
      for (var r, t = [], e = 0; e < arguments.length; e++)
        t[e] = arguments[e];
      this.type === "destination" && (r = this.middleware).push.apply(r, t);
    }, n.prototype.transform = function(r) {
      return d(this, void 0, void 0, function() {
        var t;
        return f(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, q(this.name, r.event, this.middleware)];
            case 1:
              return t = e.sent(), t === null && r.cancel(new B({
                retry: !1,
                reason: "dropped by destination middleware"
              })), [2, new F(t)];
          }
        });
      });
    }, n.prototype._createMethod = function(r) {
      var t = this;
      return function(e) {
        return d(t, void 0, void 0, function() {
          var i;
          return f(this, function(s) {
            switch (s.label) {
              case 0:
                return this.action[r] ? (i = e, this.type !== "destination" ? [3, 2] : [4, this.transform(e)]) : [2, e];
              case 1:
                i = s.sent(), s.label = 2;
              case 2:
                return [4, this.action[r](i)];
              case 3:
                return s.sent(), [2, e];
            }
          });
        });
      };
    }, n.prototype.isLoaded = function() {
      return this.action.isLoaded();
    }, n.prototype.ready = function() {
      return this.action.ready ? this.action.ready() : Promise.resolve();
    }, n.prototype.load = function(r, t) {
      return this.action.load(r, t);
    }, n.prototype.unload = function(r, t) {
      var e, i;
      return (i = (e = this.action).unload) === null || i === void 0 ? void 0 : i.call(e, r, t);
    }, n;
  }()
);
function j(n) {
  if (!Array.isArray(n))
    throw new Error("Not a valid list of plugins");
  var r = ["load", "isLoaded", "name", "version", "type"];
  return n.forEach(function(t) {
    r.forEach(function(e) {
      var i;
      if (t[e] === void 0)
        throw new Error("Plugin: ".concat((i = t.name) !== null && i !== void 0 ? i : "unknown", " missing required function ").concat(e));
    });
  }), !0;
}
function x(n, r) {
  var t = n[r.creationName], e = n[r.name];
  return n.All === !1 && !t && !e || t === !1 || e === !1;
}
function Q(n, r, t, e, i) {
  var s, h, p;
  return d(this, void 0, void 0, function() {
    var m, c, N, M, S = this;
    return f(this, function(E) {
      switch (E.label) {
        case 0:
          return m = [], c = k(), N = (h = (s = n.middlewareSettings) === null || s === void 0 ? void 0 : s.routingRules) !== null && h !== void 0 ? h : [], M = ((p = n.remotePlugins) !== null && p !== void 0 ? p : []).map(function(o) {
            return d(S, void 0, void 0, function() {
              var v, y, A, w, C, u, b, D, _;
              return f(this, function(a) {
                switch (a.label) {
                  case 0:
                    if (x(r, o))
                      return [
                        2
                        /*return*/
                      ];
                    a.label = 1;
                  case 1:
                    if (a.trys.push([1, 12, , 13]), !e) return [3, 7];
                    v = o.url.split("/"), y = v[v.length - 2], A = o.url.replace(y, btoa(y).replace(/=/g, "")), a.label = 2;
                  case 2:
                    return a.trys.push([2, 4, , 6]), [4, g(A.replace("https://cdn.segment.com", c))];
                  case 3:
                    return a.sent(), [3, 6];
                  case 4:
                    return a.sent(), [4, g(o.url.replace("https://cdn.segment.com", c))];
                  case 5:
                    return a.sent(), [3, 6];
                  case 6:
                    return [3, 9];
                  case 7:
                    return [4, g(o.url.replace("https://cdn.segment.com", c))];
                  case 8:
                    a.sent(), a.label = 9;
                  case 9:
                    return w = o.libraryName, typeof window[w] != "function" ? [3, 11] : (C = window[w], [4, C(R(R({}, o.settings), t[o.name]))]);
                  case 10:
                    u = a.sent(), b = Array.isArray(u) ? u : [u], j(b), D = N.filter(function(l) {
                      return l.destinationName === o.creationName;
                    }), b.forEach(function(l) {
                      var L = new U(o.creationName, l);
                      D.length && i && l.type === "destination" && L.addMiddleware(i), m.push(L);
                    }), a.label = 11;
                  case 11:
                    return [3, 13];
                  case 12:
                    return _ = a.sent(), console.warn("Failed to load Remote Plugin", _), [3, 13];
                  case 13:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), [4, Promise.all(M)];
        case 1:
          return E.sent(), [2, m.filter(Boolean)];
      }
    });
  });
}
export {
  U as ActionDestination,
  Q as remoteLoader
};
//# sourceMappingURL=index36.js.map
